import { request } from './apiClient';

// Lista todas as prensas.
export const getPrensa = async () => {
    return await request("/api/prensa");
};

// Cria uma prensa.
export const createPrensa = async (prensaData) => {
    return await request("/api/prensa", {
        method: 'POST',
        body: JSON.stringify(prensaData)
    });
};

// Atualiza uma prensa por id.
export const updatePrensa = async (idPrensa, prensaData) => {
    return await request(`/api/prensa/${idPrensa}`, {
        method: 'PUT',
        body: JSON.stringify(prensaData)
    });
};

// Exclui uma prensa por id.
export const deletePrensa = async (idPrensa) => {
    return await request(`/api/prensa/${idPrensa}`, {
        method: 'DELETE'
    });
};